import { name, version } from '../package.json';

export default {
    onDark: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, changes component to on-dark styling.',
        },
    },
    size: {
        type: String,
        default: 'medium',
        validator(value) {
            return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `small`, `medium`, `large`, `touch`.',
            description: 'Sets the size of the list group.',
        },
    },
    variation: {
        type: String,
        default: 'default',
        validator(value) {
            return ['default', 'selection', 'navigation'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `default`, `selection`, `navigation`.',
            description: 'Sets the list group variation.',
        },
    },
    withIcon: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, creates space in list group items for an icon.',
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
};
